interface UbbeModalFooterProps {
  primaryButtonText: string;
  secondaryButtonText?: string;
  className?: string;
  onSave: any;
  onClose: any;
}

const UbbeModalFooter = ({
  primaryButtonText,
  secondaryButtonText,
  onSave,
  className,
  onClose,
}: UbbeModalFooterProps) => {
  return (
    <div
      className={`d-flex py-2 flex-column justify-content-center ${className}`}
    >
      <p
        className='btn m-auto ubbe-blue-bg p-2 px-4 rounded-3 text-light'
        onClick={onSave}
        style={{
          width: 'max-content',
          backgroundColor: '#251163',
          fontFamily: 'Lexend',
        }}
      >
        {primaryButtonText}
      </p>
      <u
        className='m-auto mt-2 d-flex justify-content-center labelText'
        style={{ cursor: 'pointer' }}
        onClick={onClose}
      >
        {secondaryButtonText ?? 'Close'}
      </u>
    </div>
  );
};

export default UbbeModalFooter;
